<template>
  <div class="fav-page">
    <div class="page-body">
      <div class="fav-header">
        <div class="header-left">
          <h1 class="fav-title"><i class="el-icon-star-on" style="color:#e6a23c;margin-right:10px;" />{{ $t('view.favorites.title') }}</h1>
          <span class="fav-count">{{ $t('view.favorites.count', { count: favorites.length }) }}</span>
        </div>
      </div>

      <div class="tool-grid" v-if="favorites.length">
        <ToolCard v-for="tool in favorites" :key="tool.id" :tool="tool" />
      </div>

      <div class="fav-empty" v-else>
        <div class="empty-icon-wrap">
          <i class="el-icon-star-off empty-icon" />
        </div>
        <h3>{{ $t('view.favorites.emptyTitle') }}</h3>
        <p>{{ $t('view.favorites.emptyDesc') }}</p>
        <router-link to="/">
          <el-button type="primary" round size="small">{{ $t('view.favorites.discover') }}</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ToolCard from '@/components/ToolCard'

export default {
  components: { ToolCard },
  computed: {
    favorites() { return this.$store.state.favorites }
  }
}
</script>

<style scoped>
.fav-page { background: #f0f2f8; min-height: 100vh; }
.page-body { max-width: 1200px; margin: 0 auto; padding: 36px 20px 80px; }

.fav-header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 28px;
}
.header-left { display: flex; align-items: baseline; gap: 14px; }
.fav-title { font-size: 24px; font-weight: 700; color: #1a1f36; margin: 0; display: flex; align-items: center; }
.fav-count { font-size: 14px; color: #8892a6; }

.tool-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }

.fav-empty {
  text-align: center; padding: 80px 20px;
}
.empty-icon-wrap {
  width: 80px; height: 80px; border-radius: 50%;
  background: #f5f6f8; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 20px;
}
.empty-icon { font-size: 36px; color: #c0c4cc; }
.fav-empty h3 { font-size: 18px; color: #303133; margin: 0 0 8px; }
.fav-empty p { font-size: 14px; color: #909399; margin: 0 0 20px; }

@media (max-width: 960px) { .tool-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 640px) { .tool-grid { grid-template-columns: 1fr; } }
</style>
